const state = {
  loggedInUserProfile: undefined,
  loginError: undefined,
};

export default state;
